<div class="d-flex align-items-end">
  @if (mandatory === true) {
    <div class="color-red-alert font-size-16">(*)</div>
  }

  <dx-check-box [(value)]="valueBool" [disabled]="isDisabled" [text]="caption" (onValueChanged)="onValueChanged()">
    <dx-validator>
      @if (mandatory === true && valueBool != false) {
        <dxi-validation-rule type="required" message="{{ 'FIELD_IS_REQUIRED' | translate }}"></dxi-validation-rule>
      }
    </dx-validator>
  </dx-check-box>
  @if (mandatory === true && (valueBool == null || valueBool == undefined)) {
    <i class="mdi mdi-alert-circle"></i>
  }
</div>
